import classnames from 'classnames';
import React from 'react';
import { AutoFocusInside } from 'react-focus-lock';
import '../../../../atoms/icon/font-icon/font-icon.js';
import 'react-transition-group';
import '../../../../atoms/alert/inline-alert/inline-alert.js';
import '../../../../atoms/alert/standard-alert/standard-alert.js';
import 'boring-avatars';
import '../../../../atoms/tooltip/hover-tooltip/hover-tooltip.js';
import 'react-laag';
import '../../../../../styles/styled-components/alert.js';
import '../../../../../styles/styled-components/animations.js';
import '../../../../../styles/styled-components/box-shadow.js';
import '../../../../../styles/styled-components/button.js';
import 'styled-components';
import '../../../../../themes/alert.js';
import '../../../../../themes/button.js';
import '../../../../../themes/checkbox.js';
import '../../../../../themes/divider.js';
import '../../../../../themes/dropdown.js';
import '../../../../../themes/fieldset.js';
import '../../../../../themes/input.js';
import '../../../../../themes/list.js';
import '../../../../../themes/listbox.js';
import '../../../../../themes/loader.js';
import '../../../../../themes/option.js';
import '../../../../../themes/popout.js';
import '../../../../../themes/switch.js';
import '../../../../../themes/themes.js';
import '../../../../../themes/tooltip.js';
import '../../../../../styles/styled-components/font-face.js';
import '../../../../../styles/styled-components/global.js';
import '../../../../../styles/styled-components/input.js';
import '../../../../../styles/styled-components/list.js';
import '../../../../../styles/styled-components/listitem.js';
import '../../../../../styles/styled-components/media-queries.js';
import '../../../../../styles/styled-components/reset.js';
import '../../../../../styles/styled-components/outline.js';
import '../../../../../styles/styled-components/popout.js';
import '../../../../../styles/styled-components/screen-reader.js';
import '../../../../../styles/styled-components/switch.js';
import '../../../../../styles/styled-components/tooltip.js';
import '../../../../../utilities/color.js';
import 'date-fns';
import '../../../../../utilities/locale.js';
import '@brandfolder/utilities';
import '../../../../atoms/button/close-button/close-button.js';
import '../../../../atoms/button/color-button/color-button.js';
import '../../../../../hooks/use-prevent-keyboard-scrolling.js';
import '../../../../atoms/button/icon-button/icon-button.js';
import '../../../../atoms/button/standard-button/standard-button.js';
import { CircleLoader } from '../../../../atoms/loader/circle-loader/circle-loader.js';
import '../../../../atoms/loader/shimmer-loader/shimmer-loader.js';
import '../../../../atoms/divider/standard-divider/standard-divider.js';
import '../../../../atoms/fieldset/standard-fieldset/standard-fieldset.js';
import '../../../../atoms/heading/standard-heading/standard-heading.js';
import '../../../../atoms/label/standard-label/standard-label.js';
import '../../../../atoms/link/button-link/button-link.js';
import '../../../../atoms/link/standard-link/standard-link.js';
import '../../../../atoms/popout/standard-popout/standard-popout.js';
import '../../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js';
import '../../../../atoms/table/standard-table/caption.js';
import '../../../../atoms/table/standard-table/tbody.js';
import '../../../../atoms/table/standard-table/tr-empty.js';
import '../../../../atoms/table/standard-table/td.js';
import '../../../../atoms/table/standard-table/tr.js';
import '../../../../atoms/table/standard-table/table.js';
import '../../../../atoms/table/standard-table/tfoot.js';
import '../../../../atoms/table/standard-table/th.js';
import '../../../../atoms/table/standard-table/thead.js';
import '../../../../atoms/table/dnd-table/dnd-handle-td.js';
import '../../../../atoms/table/dnd-table/dnd-table-drag-context.js';
import '../../../../atoms/text/help-text/help-text.js';
import '../../../../atoms/text/standard-text/standard-text.js';

/**
 * Base dialog body
 * @param props DialogBodyProps
 */ const DialogBody = (props)=>{
    const { autoFocus = true, children, className, contentCentered, loaderLabel, loading, ...otherProps } = props;
    const renderBody = ()=>{
        return /*#__PURE__*/ React.createElement(React.Fragment, null, !loading && children, loaderLabel && loading && /*#__PURE__*/ React.createElement(CircleLoader, {
            label: loaderLabel
        }));
    };
    return /*#__PURE__*/ React.createElement("div", {
        ...otherProps,
        className: classnames({
            'bf-dialog__body': true,
            'bf-dialog__body--centered': contentCentered,
            'bf-dialog__body--loading': loading,
            [`${className}`]: !!className
        })
    }, autoFocus ? /*#__PURE__*/ React.createElement(AutoFocusInside, {
        className: "bf-dialog__autofocus"
    }, renderBody()) : renderBody());
};

export { DialogBody };
//# sourceMappingURL=dialog-body.js.map
